export const environment = {
  production: true,
  testing: false,
  apiHost: 'https://api.moxi.health/api',
  googleMapsLibraries: ['places']
};
